var barba = require( '@barba/core');

const replaceHeadTags = target => {
    const head = document.head
    const body = document.body
    const targetHead = target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0]
    const targetBody = target.html.match(/<body[^>]*>([\s\S.]*)<\/body>/i)[0]
    const newPageHead = document.createElement('head')
    const newPageBody = document.createElement('body')
    newPageHead.innerHTML = targetHead
    newPageBody.innerHTML = targetBody
    const removeHeadTags = [
      "meta[name='keywords']",
      "meta[name='description']",
      "meta[property^='fb']",
      "meta[property^='og']",
      "meta[name^='twitter']",
      "meta[name='robots']",
      'meta[itemprop]',
      'link[itemprop]',
      "link[rel='prev']",
      "link[rel='next']",
      "link[rel='canonical']",
    ].join(',')
    const replaceScript = [
      "script"
    ].join(',')
    const headTags = [...head.querySelectorAll(removeHeadTags)]
    headTags.forEach(item => {
      head.removeChild(item)
    })
    const newHeadTags = [...newPageHead.querySelectorAll(removeHeadTags)]
    newHeadTags.forEach(item => {
      head.appendChild(item)
    })

    const scriptTags = [...body.querySelectorAll(replaceScript)]
    scriptTags.forEach(item => {
      body.removeChild(item)
    })
    const newScript = [...newPageBody.querySelectorAll(replaceScript)]
    newScript.forEach(item => {
      body.appendChild(item)
    })
  }
  
  //googleアナリティクスを使うとき
  const gaPush = pagename => {
    // ga('send', 'pageview', pagename)
  }

  barba.init({
    transitions: [
        
      {
        name: 'custom-transition',
        sync: false,
        leave(){
            // console.log('leave');
            document.getElementById('mask').classList.add('active');
            setTimeout(function(){
            document.getElementsByClassName('mask__bg')[0].classList.remove('hiddens');
            },100);
            return new Promise(resolve=>{
                setTimeout(function(){
                    resolve();
                },1000);
            })
        },
        enter(data) {
          
            document.getElementsByClassName('mask__bg')[0].classList.add('hiddens');
            setTimeout(function(){
              document.getElementById('mask').classList.remove('active');
              // spMenuShow();
              // console.log('enter');
            },800)
            // console.log('enter');
          },
        beforeEnter({ next }) {
          $(window).scrollTop(0);
          // replaceHeadTags(next);
          // console.log('beforeenter');
          
          //googleアナリティクスを使う時
        //   gaPush(location.pathname)
        }
      }
    ],
    views: [{
      namespace: 'history',
      beforeEnter({ next }) {
          let script = document.createElement('script');
          script.src = 'assets/js/history.js';
          $(window).scrollTop(0);
          spMenuShow();
          $('body').addClass('history');
          if(!$('footer').hasClass('footer--level2')){
            $('footer').addClass('footer--level2');
            }
          next.container.appendChild(script);
      },beforeLeave({data}){
        // console.log('beforeleave');
        $('body').removeClass('history');
        historyApp.$destroy();
        $('body').off('.historyscrolls');
        $(window).off('.historyresizes');
      }
    },{
      namespace: 'home',
      beforeEnter({ next }) {
        setTimeout(function(){
        $(window).resize();
        },500);
        spMenuShow();
        // console.log('home');
        if($('footer').hasClass('footer--level2')){
          $('footer').removeClass('footer--level2');
          }
          let script = document.createElement('script');
          script.src = 'assets/js/topScript.js';
          $(window).scrollTop(0);
          $('body').addClass('home');
          
          next.container.appendChild(script);
      },leave(){
        $('body').removeClass('home');
      }
    },{
      namespace: 'special',
      beforeEnter({ next }) {
        setTimeout(function(){
        $(window).resize();
        },500);
        spMenuShow();
        // console.log('special');
          let script = document.createElement('script');
          script.src = 'assets/js/special.js';
          $(window).scrollTop(0);
          $('body').addClass('special');
          if(!$('footer').hasClass('footer--level2')){
          $('footer').addClass('footer--level2');
          }
          
          next.container.appendChild(script);
      },leave(){
        $('body').removeClass('special');
      }
    }]
  })
  barba.hooks.after((data) => {
    if (typeof gtag === 'function') {
      gtag('config', 'UA-4828024-1', {page_path: window.location.pathname});
        // gtag('config', window.GA_MEASUREMENT_ID,{
        //     page_path: window.location.pathname
        // });
    }
});
  window.onload = function(){
    // setTimeout(function(){
    // document.getElementsByClassName('mask__bg')[0].classList.remove('hiddens');
    // },100);
  }

  /*
    モバイル時のメニュー表示・非表示
====================================*/
function spMenuShow() {
  
  $('.btn-trigger2').off('click.spMenuShow');
  $('.btn-trigger2').on('click.spMenuShow', function() {
    // console.log($(this));
    $('header.navbar nav').toggleClass('active');
    $(this).toggleClass('active');
    return false;
  });
}